/* 定义统计图表格使用公共参数 */
const option_bar = {
    color: [],
    title: {
        text: '',
        left: 'left',
        textStyle:{
            fontSize:12,
            color:'#222121',
            fontWeight:'normal'
        }
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow'
        }
    },
    legend: {
        data: []
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: {
        type: 'value',
        data: [],
        splitLine: {}
    },
    yAxis: {
        type: 'category',
        data: [],
        splitLine: {}
    },
    series: [
        {
            type: 'bar',
            itemStyle: {
              normal: {
                color: '#ff8383'
              }
            },
            data: []
        }
    ]
  };
const option_pie = {
    title: {
        text: '',
        left: 'left',
        textStyle:{
            fontSize:12,
            color:'#222121',
            fontWeight:'normal'
        }
    },
    tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
        orient: 'horizontal',
        bottom: 10,
        data: []
    },
    series: [
        {
            name: '',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
                normal: {
                    show: false,
                    position: 'center'
                },
                emphasis: {
                    show: true,
                    textStyle: {
                        fontSize: '12',
                        fontWeight: 'bold'
                    }
                }
            },
            data: []
        }
    ]
  };
const option_line = {
    title: {
        text: '',
        left: 'left',
        textStyle:{
            fontSize:12,
            color:'#222121',
            fontWeight:'normal'
        }
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'cross',
            label: {
                backgroundColor: '#6a7985'
            }
        }
    },
    legend: {
        data: []
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    // toolbox: {
    //     feature: {
    //         saveAsImage: {}
    //     }
    // },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data: []
    },
    yAxis: {
        type: 'value'
    },
    series: []
};

/*网格地图专用统计图表配置 */
const option_gridding_bar = {
    title: {
      text: "",
      top: 5,
      textStyle: {
        color: "#fff",
        fontSize: 14
      }
    },
    color: ["#3398DB"],
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow"
      }
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true
    },
    xAxis: [
      {
        type: "category",
        data: [],
        axisTick: {
          alignWithLabel: true
        },
        axisLine: {
          lineStyle: {
            color: "#485f92"
          }
        },
        axisLabel: {
          color: "#fff",
          interval: 0
        }
      }
    ],
    yAxis: [
      {
        type: "value",
        axisLine: {
          lineStyle: {
            color: "#485f92"
          }
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: ["#315070"],
            width: 1,
            type: "solid"
          }
        }
      }
    ],
    series: [{
      type: "bar",
      barWidth: "60%",
      data: [],
      barWidth: 15,
      itemStyle: {
        normal: {
          //每根柱子颜色设置
          color: function(params) {
            let colorList = ["#126ada", "#fece01", "#45c1e1", "#fe741b"];
            return colorList[params.dataIndex];
          }
        }
      }
    }]
  }
const option_gridding_pie = {
    title: {
        text:'',
        left: 'left',
        top: 5,
        textStyle: {
            color: '#ccc',
            fontSize: 14
        }
    },
    tooltip: {
        trigger: 'item',
        formatter: "{b} : {c} ({d}%)"
    },
    visualMap: {
        show: false,
        min: 500,
        max: 600,
        inRange: {
            //colorLightness: [0, 1]
        }
    },
    series: [{
        type: 'pie',
        radius: '50%',
        center: ['50%', '50%'],
        color: ['rgb(131,249,103)', '#FBFE27', '#FE5050', '#1DB7E5'], //'#FBFE27','rgb(11,228,96)','#FE5050'
        data: [],
        roseType: 'radius',
        label: {
            normal: {
                formatter: ['{b|{b}}'].join('\n'),
                rich: {
                    c: {
                        color: 'rgb(241,246,104)',
                        fontSize: 12,
                        fontWeight:'bold',
                        lineHeight: 5
                    },
                    b: {
                        color: 'rgb(98,137,169)',
                        fontSize: 12,
                        height: 32
                    },
                },
            }
        },
        labelLine: {
            normal: {
                lineStyle: {
                    color: 'rgb(98,137,169)',
                },
                smooth: 0.2,
                length: 10,
                length2: 20,
            }
        },
        itemStyle: {
            normal: {
                shadowColor: 'rgba(0, 0, 0, 0.8)',
                shadowBlur: 50,
            }
        }
    }]
  }
const option_gridding_pie_radius = {
    color: ['#8d7fec', '#5085f2', '#e75fc3', '#f87be2', '#f2719a', '#fca4bb', '#f59a8f', '#fdb301', '#57e7ec','#cf9ef1'],
    title: {
        text: "",
        padding: [10, 20, 20, 10],
        textStyle: {
        color: "#fff",
        fontSize: 14
        }
    },
    color: ["#ff6a6a", "#10b9f8", "#4cabce", "#e5323e"],
    tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b}: {c} ({d}%)"
    },
    series: [{
        type: "pie",
        radius: ["40%", "60%"],
        avoidLabelOverlap: false,
        label: {
            normal: {
            show: false,
            position: "center"
            },
            emphasis: {
            show: true,
            textStyle: {
                fontSize: "14",
                fontWeight: "bold"
            }
            }
        },
        labelLine: {
            normal: {
            show: false
            }
        },
        data: []
        }
    ]}

const myColor = ['#eb2100', '#eb3600', '#d0570e', '#d0a00e', '#34da62'];
const option_gridding_bar_gap = {
    // backgroundColor: '#0e2147',
    title: {
        text: "",
        top: 5,
        textStyle: {
          color: "#fff",
          fontSize: 14
        }
      },
    grid: {
        left: '5%',
        top: '5%',
        right: '1%',
        bottom: '2%',
        containLabel: true
    },
    xAxis: [{
        show: false,
    }],
    yAxis: [{
        axisTick: 'none',
        axisLine: 'none',
        offset: '10',
        axisLabel: {
            textStyle: {
                color: '#ffffff',
                fontSize: '10',
            }
        },
        data: []
    }, {
        axisTick: 'none',
        axisLine: 'none',
        axisLabel: {
            textStyle: {
                color: '#ffffff',
                fontSize: '10',
            }
        },
        data: []
    }, {
        nameGap: '50',
        nameTextStyle: {
            color: '#ffffff',
            fontSize: '10',
        },
        axisLine: {
            lineStyle: {
                color: 'rgba(0,0,0,0)'
            }
        },
        data: [],
    }],
    series: [{
            name: '条',
            type: 'bar',
            yAxisIndex: 0,
            data: [],
            label: {
                normal: {
                    show: true,
                    position: 'right',
                    textStyle: {
                        color: '#ffffff',
                        fontSize: '10',
                    }
                }
            },
            barWidth: 4,
            itemStyle: {
                normal: {
                    color: function(params) {
                        var num = myColor.length;
                        return myColor[params.dataIndex % num]
                    },
                }
            },
            z: 2
        }, {
            name: '白框',
            type: 'bar',
            yAxisIndex: 1,
            barGap: '-100%',
            data: [99, 99.5, 99.5, 99.5, 99.5],
            barWidth: 6,
            itemStyle: {
                normal: {
                    color: '#0e2147',
                    barBorderRadius: 2,
                }
            },
            z: 1
        }, {
            name: '外框',
            type: 'bar',
            yAxisIndex: 2,
            barGap: '-100%',
            data: [100, 100, 100, 100, 100],
            barWidth: 8,
            itemStyle: {
                normal: {
                    color: function(params) {
                        var num = myColor.length;
                        return myColor[params.dataIndex % num]
                    },
                    barBorderRadius: 5,
                }
            },
            z: 0
        },
        {
            name: '外圆',
            type: 'scatter',
            hoverAnimation: false,
            data: [0, 0, 0, 0, 0],
            yAxisIndex: 2,
            symbolSize: 8,
            itemStyle: {
                normal: {
                    color: function(params) {
                        var num = myColor.length;
                        return myColor[params.dataIndex % num]
                    },
                    opacity: 1,
                }
            },
            z: 2
        }
    ]
  }

export default{
    option_bar,    //柱状图配置
    option_pie,   //饼状图默认配置
    option_line,
    option_gridding_bar,
    option_gridding_pie,
    option_gridding_pie_radius,
    option_gridding_bar_gap
}
